import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect';

export default function UiHeaderWr(props) {

    useEffect(function () {
        window.addEventListener('scroll', () => {
            if (!isMobile) {
            let scrollTop = window.scrollY;
            let activeLink = document.querySelector('.sb-slider-bottom-line');
            const header = document.querySelector('header');

            if (activeLink !== null) {
                if (scrollTop >= activeLink.offsetTop) {
                    // header.style.backgroundColor = '#FD7D56';
                }
                else {
                    // header.style.backgroundColor = '#FFF';
                }
            }
        }
        })
    },[])
    return (
        <>
            <header  >
                <div className='sb-top-nav-wr' >
                    <nav className="navbar  navbar-expand-xl">
                        {props.children}
                    </nav>
                </div>
            </header>
        </>
    )
}

